import React from 'react';
import { styled } from '@elliemae/ds-system';
import { DSLeftNavigationName, LEFT_NAVIGATION_DATA_TESTID, LEFT_NAVIGATION_SLOTS } from '../../constants/index.js';
import { ItemRenderer } from '../../exported-related/index.js';
import type { DSLeftNavigationT } from '../../react-desc-prop-types.js';

const StyledSeparator = styled('div', { name: DSLeftNavigationName, slot: LEFT_NAVIGATION_SLOTS.ITEM_SEPARATOR })`
  height: 1px;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  width: auto;
  margin: ${(props) => props.theme.space.xxxs} 0;
  margin-left: ${(props) => props.theme.space.xxxs};
  grid-column: span 3;
`;

export const ItemSeparator = (props: DSLeftNavigationT.ComponentProps): JSX.Element => {
  const {
    item,
    ctx: { leftNavProps },
  } = props;
  const getOwnerProps = React.useCallback(() => leftNavProps, [leftNavProps]);
  const getOwnerPropsArguments = React.useCallback(() => ({}), []);
  return (
    <ItemRenderer
      item={{
        ...item,
        itemOpts: {
          ...item.itemOpts,
          ariaRole: 'separator',
          selectable: false,
          focuseable: false,
        },
        CollapsedComponent: null,
      }}
      minHeight="1px"
      paddingTop="0px"
    >
      <StyledSeparator
        data-testid={LEFT_NAVIGATION_DATA_TESTID.ITEM_SEPARATOR} // https://jira.elliemae.io/browse/PUI-15589
        getOwnerProps={getOwnerProps}
        getOwnerPropsArguments={getOwnerPropsArguments}
      />
    </ItemRenderer>
  );
};
